import React from "react";
import { CustomMenuItems } from "./CustomMenuItems";
import { MenuItem } from "./MenuItem";
import { getPermissions } from "@/stores/globalStore";

export const MarketingMenuItems = () => {
    const permissions = getPermissions(); // Fetch permissions using getPermissions

    const conversionTrackingInitialRoute = permissions.canViewCustomConversionTracking
        ? "marketing/conversionTracking/customCode"
        : "marketing/conversionTracking/facebook";

    return (
        <>
            {permissions.canViewAbandoned && (
                <MenuItem isSubMenuItem route="abandonedBookingRecovery" label="Abandoned Reservation Recovery" />
            )}
            {permissions.canViewConversionTracking && (
                <MenuItem isSubMenuItem route={conversionTrackingInitialRoute} label="Conversion Tracking" />
            )}
            {permissions.canViewCoupons && <MenuItem isSubMenuItem route="marketing/coupons" label="Coupons" />}
            {/* TBD: Adding Cross account selling account menu item */}
            {permissions.canViewXolaBot && <MenuItem isSubMenuItem route="marketing/xolabot" label="XolaBot" />}
            {permissions.canViewServerSideTracking && (
                <MenuItem isSubMenuItem route="marketing/serverSideTracking" label="Server Side Tracking" />
            )}
            <CustomMenuItems route="marketing" />
        </>
    );
};
